var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'absolute',
    'flex',
    'items-center',
    'justify-center',
    'p-0.875',
    'rounded-full',
    'top-0',
    'left-0',
    'bottom-0',
    'right-0',
  ]},[_c('OzBaseButton',{class:[
      // Shape
      'h-8',
      'w-8',
      'rounded-full',

      // Centralize button content
      'flex',
      'items-center',
      'justify-center',

      // Colors
      _vm.buttonColorClass,
      _vm.buttonHoverColorClass,
      _vm.buttonIconColorClass,
    ],attrs:{"title":_vm.iconName === 'play' ? _vm.__('Play attachment') : _vm.__('Download attachment'),"aria-label":_vm.iconName === 'play' ? _vm.__('Play attachment') : _vm.__('Download attachment')},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('OzIcon',{attrs:{"name":_vm.iconName,"size":16}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }